// Fino — Shorten size labels on the main variant picker (display-only)
(function () {
  'use strict';

  const SIZE_MAP = {
    'X-SMALL': 'XS',
    'EXTRA SMALL': 'XS',
    'XSMALL': 'XS',
    'SMALL': 'S',
    'MEDIUM': 'M',
    'LARGE': 'L',
    'X-LARGE': 'XL',
    'EXTRA LARGE': 'XL',
    'XLARGE': 'XL',
    'XX-LARGE': 'XXL',
    '2X-LARGE': 'XXL',
    'XXLARGE': 'XXL',
    '2XL': 'XXL',
    'XXX-LARGE': 'XXXL',
    '3X-LARGE': 'XXXL',
    '3XL': 'XXXL',
  };

  function shortLabelFor(text) {
    if (!text) return null;
    const key = text.trim().toUpperCase();
    return SIZE_MAP[key] || null;
  }

  function isSizeFieldset(fieldset) {
    // Horizon marks option groups with legend text or a data attribute
    const legend = fieldset.querySelector('legend');
    const label = fieldset.getAttribute('aria-label') || fieldset.dataset.optionName || '';
    const legendText = legend ? legend.textContent : '';
    return /size/i.test(legendText) || /size/i.test(label);
  }

  function shortenPillsInFieldset(fieldset) {
    // Horizon renders variant pills with a text span inside the label of each radio
    const labels = fieldset.querySelectorAll('label');

    labels.forEach((label) => {
      // Find the visible text node (skip inputs and hidden elements)
      const textTargets = label.querySelectorAll('span, div');

      textTargets.forEach((el) => {
        // Only touch leaf text nodes so we don't clobber nested structure
        if (el.children.length > 0) return;

        const original = el.textContent;
        const shortened = shortLabelFor(original);

        if (shortened && el.dataset.finoOriginal === undefined) {
          el.dataset.finoOriginal = original; // backup so we don't re-transform
          el.textContent = shortened;
        }
      });

      // Edge case: text directly inside <label> with no wrapping span
      label.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const original = node.textContent.trim();
          const shortened = shortLabelFor(original);
          if (shortened && !label.dataset.finoOriginalText) {
            label.dataset.finoOriginalText = original;
            node.textContent = shortened;
          }
        }
      });
    });
  }

  function shortenDropdownOptions(select) {
    Array.from(select.options).forEach((option) => {
      if (option.dataset.finoOriginal !== undefined) return;
      const shortened = shortLabelFor(option.textContent);
      if (shortened) {
        option.dataset.finoOriginal = option.textContent;
        option.textContent = shortened;
      }
    });
  }

  function processVariantPicker(picker) {
    if (!picker) return;

    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      if (isSizeFieldset(fieldset)) {
        shortenPillsInFieldset(fieldset);
      }
    });

    picker.querySelectorAll('select').forEach((select) => {
      const name = (select.getAttribute('name') || select.dataset.optionName || '').toLowerCase();
      const labelText = (select.closest('.variant-option')?.querySelector('label')?.textContent || '').toLowerCase();
      if (name.includes('size') || labelText.includes('size')) {
        shortenDropdownOptions(select);
      }
    });
  }

  function processAll() {
    document.querySelectorAll('variant-picker').forEach(processVariantPicker);
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  // Re-run after Horizon's morph re-renders the picker on variant change
  document.addEventListener('variant:change', () => setTimeout(processAll, 50));
  document.addEventListener('variantchange', () => setTimeout(processAll, 50));

  // Watch for DOM mutations inside any variant-picker (covers morph re-renders)
  if ('MutationObserver' in window) {
    const pickers = document.querySelectorAll('variant-picker');
    pickers.forEach((picker) => {
      const observer = new MutationObserver(() => {
        clearTimeout(window.__finoSizeLabelTimer);
        window.__finoSizeLabelTimer = setTimeout(() => processVariantPicker(picker), 30);
      });
      observer.observe(picker, { childList: true, subtree: true, characterData: true });
    });

    // Also watch for variant-picker elements being added later (combined listings)
    const bodyObserver = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches('variant-picker')) {
            processVariantPicker(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('variant-picker').forEach(processVariantPicker);
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();